import { useEffect } from "react";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { AuthView } from "~/components/auth/AuthView";
import { useAuth } from "~/hooks/useAuth";

export const Route = createFileRoute("/")({
  component: RouteComponent,
  beforeLoad: ({ context: { authClient } }) => {
    if (authClient.user?.isAuthenticated) {
      throw redirect({
        to: "/ejendomstjek",
        replace: true,
      });
    }
  },
});

function RouteComponent() {
  const { user } = useAuth();
  const navigate = useNavigate();

  // This view stays mounted while the user authenticates, so we need to react to changes in the user state and redirect if they are authenticated.
  useEffect(() => {
    if (user?.isAuthenticated) {
      void navigate({
        to: "/ejendomstjek",
        replace: true,
      });
    }
  }, [user?.isAuthenticated]);

  return <AuthView />;
}
